import riderMessages from 'core/data-model/constants/validation-messages'

export const checkInvalidOccupationFactorRule = (rule, eligibilities) => {
  let errorMessage = ''

  if (eligibilities.occupationFactor === rule.value) {
    errorMessage = riderMessages.RULE_RIDER_OCCUPATION_FACTOR
  }
  return {
    type: rule.validationType,
    message: errorMessage,
  }
}
